export { branding, type Branding } from "./branding";
export { injectTheme } from "./theme";
export { injectFont } from "./fonts";

/** ID do agente padrão. Garantido pela migration 4c768a479074_seed_default_agent. */
export const DEFAULT_AGENT_ID = 1;
